import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
} from "react-native";
import { useRecoilValue } from "recoil";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";
import { getCompetitionComponents, deleteUser } from "../../action/authAction";
import { useIsFocused } from "@react-navigation/native";
import { tokenState } from "../../reducer/recoil";
import { styles, stylesResponsive } from "./style";
import Modal from "modal-react-native-web";
import { apiservice } from "../../service";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, error }) {
  const token = useRecoilValue(tokenState);
  const [modalSendmail, setModalSendmail] = useState(false);
  const [data, setData] = useState([]);
  const [text, setText] = useState("");
  const [show, setShow] = useState(false);

  const isFocused = useIsFocused();
  const [country, setCountry] = useState([]);
  const [fil, setFil] = useState("");

  useEffect(() => {
    callCoutry();
  }, [isFocused, token]);

  async function callCoutry() {
    const response = await getCompetitionComponents(token.token);
    if (response) {
      setData(response.getCountriesComponent);
      setCountry(
        response.getCountriesComponent.map((item) => {
          return { label: item.country_name, value: item.country_name };
        })
      );
      console.log(
        response.getCountriesComponent.map((item) => {
          return { label: item.country_name, value: item.country_name };
        })
      );
      setTimeout(() => {
        setShow(true);
      }, 100);
    }
  }

  console.log(token.token);

  return (
    <View style={styles.container}>
      <Header
        backgroundColorCountries="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background navigation={navigation} Title="COUNTRIES" admin />
          {show && (
            <TabbarOption
              country={country}
              onfilter={(val) => {
                if (val != "Countries") {
                  setFil(val);
                } else {
                  setFil("");
                }
              }}
              buttonTabbar
              dropdownCountries
              onPressAdd={() => {
                navigation.navigate("CountriesAdd");
              }}
              onChangeText={(text) => {
                setText(text);
              }}
            />
          )}
          {width > 500 && (
            <View style={[styles.viewTopic]}>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { maxWidth: 120, width: "100%" },
                ]}
              >
                {"IMAGE"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { width: "10%" },
                ]}
              ></Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { width: "15%" },
                ]}
              >
                {"COUNTRY"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"ABBREVIATION"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {"USER NAME"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                  { width: "15%" },
                ]}
              >
                {"E-mail"}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTitleRespons : styles.textTitle,
                ]}
              >
                {""}
              </Text>
            </View>
          )}
          <FlatList
            data={data
              .filter((item) =>
                item.country_name.toLowerCase().includes(text.toLowerCase())
              )
              .filter((item) =>
                item.country_name.toLowerCase().includes(fil.toLowerCase())
              )}
            scrollEnabled={width < 1280 ? true : false}
            renderItem={({ index, item }) => {
              return width > 500 ? (
                <View
                  style={[
                    styles.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <View
                    style={{
                      flexDirection: "row",
                      width: "10%",
                      justifyContent: "center",
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        navigation.navigate("CountriesEdit", item);
                      }}
                      style={styles.buttomDetail}
                    >
                      <Text
                        style={
                          width < 1600
                            ? styles.textButtonDetailRespons
                            : styles.textButtonDetail
                        }
                      >
                        EDIT
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={async () => {
                        const respose = await deleteUser({
                          id: item.Association[0].User.user_id,
                          token: token.token,
                        });
                        if (respose) {
                          callCoutry();
                        }
                      }}
                      style={styles.buttomDetail}
                    >
                      <Text
                        style={
                          width < 1600
                            ? styles.textButtonDetailRespons
                            : styles.textButtonDetail
                        }
                      >
                        DELETE
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <Text
                    numberOfLines={1}
                    style={[styles.textDetail, { width: "15%" }]}
                  >
                    {item.country_name}
                  </Text>
                  <Text numberOfLines={1} style={[styles.textDetail]}>
                    {item.abbreviation}
                  </Text>
                  <Text numberOfLines={1} style={[styles.textDetail]}>
                    {item.Association.length > 0
                      ? item.Association[0].User.username
                      : ""}
                  </Text>
                  <View style={{ width: "15%" }}>
                    <Text
                      numberOfLines={1}
                      style={[styles.textDetail, { width: "100%" }]}
                    >
                      {item.Association.length > 0
                        ? item.Association[0].email
                        : ""}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[styles.textDetail, { width: "100%" }]}
                    >
                      {item.Association.length > 0
                        ? item.Association[0].sub_email
                        : ""}
                    </Text>
                  </View>
                  <View style={{ width: "10%", justifyContent: "center" }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await apiservice({
                          path: "/user/sendInfo",
                          method: "Post",
                          body: { user_id: item.Association[0].User.user_id },
                          token: token.token,
                        });
                        if (response.status == 200) {
                          setModalSendmail(true);
                          setTimeout(() => {
                            setModalSendmail(false);
                          }, 2000);
                        }
                      }}
                      style={{
                        width: 104,
                        height: 43,
                        backgroundColor: "#FFFFFF",
                        borderRadius: 25,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: "Prompt",
                          color: "#2D69AE",
                        }}
                      >
                        SEND MAIL
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ) : (
                <View
                  style={[
                    stylesResponsive.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <View style={{ width: "60%" }}>
                    <View
                      style={{
                        flexDirection: "row",
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate("CountriesEdit", item);
                        }}
                        style={stylesResponsive.buttomDetail}
                      >
                        <Text style={stylesResponsive.textButtonDetail}>
                          EDIT
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={async () => {
                          const respose = await deleteUser({
                            id: item.Association[0].User.user_id,
                            token: token.token,
                          });
                          if (respose) {
                            callCoutry();
                          }
                        }}
                        style={stylesResponsive.buttomDetail}
                      >
                        <Text style={stylesResponsive.textButtonDetail}>
                          DELETE
                        </Text>
                      </TouchableOpacity>
                    </View>

                    <Text numberOfLines={1} style={stylesResponsive.textTitle}>
                      COUNTRY
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.country_name}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTitle}>
                      ABBREVIATION
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.abbreviation}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTitle}>
                      USER NAME
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.Association.length > 0
                        ? item.Association[0].User.username
                        : ""}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTitle}>
                      E-mail
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.Association.length > 0
                        ? item.Association[0].email
                        : ""}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.Association.length > 0
                        ? item.Association[0].sub_email
                        : ""}
                    </Text>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await apiservice({
                          path: "/user/sendInfo",
                          method: "Post",
                          body: { user_id: item.Association[0].User.user_id },
                          token: token.token,
                        });
                        if (response.status == 200) {
                          setModalSendmail(true);
                          setTimeout(() => {
                            setModalSendmail(false);
                          }, 2000);
                        }
                      }}
                      style={{
                        width: 104,
                        height: 43,
                        backgroundColor: "#FFFFFF",
                        borderRadius: 25,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: "Prompt",
                          color: "#2D69AE",
                        }}
                      >
                        SEND MAIL
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
          />
        </View>
        <Modal
          animationType="fade"
          transparent={true}
          visible={modalSendmail}
          onRequestClose={() => {
            Alert.alert("Modal has been closed.");
            setModalSendmail(!modalSendmail);
          }}
        >
          <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
            <View
              style={[
                styles.viewStatusMailModal,
                {
                  width: width < 1280 ? width * 0.8 : width * 0.4,
                  backgroundColor: error ? "#FFDEDE" : "#A7FFB2",
                  borderColor: error ? "#B12B2B" : "#36FF5E",
                },
              ]}
            >
              <Text
                style={[
                  styles.textStatusMailModal,
                  {
                    fontSize: width < 1280 ? 22 : 28,
                    color: error ? "#B23131" : "#2BB165",
                  },
                ]}
              >
                {error
                  ? "E-MAIL NOT SEND. PLEASE TRY AGAIN"
                  : "E-MAIL SEND SUCCESS"}
              </Text>
            </View>
          </View>
        </Modal>
      </ScrollView>
    </View>
  );
}
